import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import { alpha, styled, type Theme } from "@mui/material/styles";

const wholeAccent = (theme: Theme) =>
  theme.palette.mode === "dark" ? theme.palette.gold : theme.palette.yellow;

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$whole",
})<{ $whole: boolean }>(({ $whole, theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.375, 0.75),
  borderRadius: 999,
  minWidth: 0,
  border: `1px solid ${$whole ? wholeAccent(theme).dark : theme.palette.divider}`,
  backgroundColor: $whole
    ? alpha(
        wholeAccent(theme).main,
        theme.palette.mode === "dark" ? 0.16 : 0.15
      )
    : alpha(theme.palette.text.primary, 0.02),
}));

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$color",
})<{ $color: string }>(({ $color }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: $color,
  flexShrink: 0,
}));

export const Label = styled(Box)({
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  fontSize: 13,
  fontWeight: 500,
});

export const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$whole",
})<{ $whole: boolean }>(({ $whole, theme }) => ({
  fontSize: "inherit",
  fontWeight: "inherit",
  color: $whole ? wholeAccent(theme).dark : theme.palette.text.primary,
  maxWidth: 120,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const Suffix = styled(Typography)(({ theme }) => ({
  fontSize: "inherit",
  fontWeight: "inherit",
  color: theme.palette.text.primary,
  whiteSpace: "nowrap",
  flexShrink: 0,
}));

export const SuffixBadge = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: wholeAccent(theme).dark,
  whiteSpace: "nowrap",
  flexShrink: 0,
  padding: theme.spacing(0, 0.625),
  marginLeft: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(
    wholeAccent(theme).main,
    theme.palette.mode === "dark" ? 0.16 : 0.45
  ),
}));

export const RemoveButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  marginLeft: theme.spacing(0.25),
  color: theme.palette.text.disabled,

  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.text.secondary,
  },
}));

export const RemoveIcon = styled(CloseIcon)({
  fontSize: 14,
});
